// Infinite scroll for the browse grid.
//
// The server renders a #load-more element under the grid carrying the next
// page's URL (browse/_load_more.html.erb). When it scrolls into view, or its
// "Load more" button is pressed, that URL is fetched as a script response
// (browse/redesign.js.erb), which appends the cards and replaces #load-more
// with the following page's URL or an end line. Search and filter responses
// replace #load-more too, and fire browse:updated so the observer re-arms.
$(document).ready(function() {
  if (!document.getElementById('profiles-list')) {
    return;
  }

  let loading = false;
  let observer = null;

  function sentinel() {
    return document.getElementById('load-more');
  }

  function loadNext() {
    const el = sentinel();
    const url = el && el.dataset.nextUrl;
    if (!url || loading) {
      return;
    }

    loading = true;
    el.classList.add('br-load-more--loading');

    $.ajax({ url: url, type: 'GET', dataType: 'script' })
      .fail(function() {
        el.classList.remove('br-load-more--loading');
        console.error('Loading more profiles failed');
      })
      .always(function() {
        loading = false;
        observe();
      });
  }

  // Watch the current sentinel; it is a new element after every response.
  function observe() {
    if (observer) {
      observer.disconnect();
    }

    const el = sentinel();
    if (!el || !el.dataset.nextUrl || !('IntersectionObserver' in window)) {
      return;
    }

    observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        loadNext();
      }
    }, { rootMargin: '400px 0px' });
    observer.observe(el);
  }

  $(document).on('click', '#load-more-btn', loadNext);
  $(document).on('browse:updated', observe);
  observe();
});
